
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import VideoGallery from '../pages/gallery/video/page';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PrincipalMessagePage = lazy(() => import('../pages/about/principal-message/page'));
const DirectorMessagePage = lazy(() => import('../pages/about/director-message/page'));
const HistoryPage = lazy(() => import('../pages/about/history/page'));
const TeamPage = lazy(() => import('../pages/about/team/page'));
const AdvisoryBoardPage = lazy(() => import('../pages/about/advisory-board/page'));
const VacanciesPage = lazy(() => import('../pages/about/vacancies/page'));
const AcademicsPage = lazy(() => import('../pages/academics/page'));
const EarlyYearsPage = lazy(() => import('../pages/academics/early-years/page'));
const PrimaryPage = lazy(() => import('../pages/academics/primary/page'));
const SecondaryPage = lazy(() => import('../pages/academics/secondary/page'));
const AdmissionsPage = lazy(() => import('../pages/admissions/page'));
const AdmissionsProcessPage = lazy(() => import('../pages/admissions/process/page'));
const ExamsPage = lazy(() => import('../pages/admissions/exams/page'));
const VirtualTourPage = lazy(() => import('../pages/admissions/virtual-tour/page'));
const StudentLifePage = lazy(() => import('../pages/student-life/page'));
const SportsPage = lazy(() => import('../pages/student-life/sports/page'));
const LeadershipPage = lazy(() => import('../pages/student-life/leadership/page'));
const AlumniPage = lazy(() => import('../pages/student-life/alumni/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const AdminPortalPage = lazy(() => import('../pages/portal/admin/page'));
const TeachersPortalPage = lazy(() => import('../pages/portal/teachers/page'));
const ParentPortalPage = lazy(() => import('../pages/portal/parents/page'));
const AlumniPortalPage = lazy(() => import('../pages/portal/alumni/page'));
const StudentPortalPage = lazy(() => import('../pages/portal/students/page'));
const CheckResultPage = lazy(() => import('../pages/portal/results/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/about/principal-message',
    element: <PrincipalMessagePage />,
  },
  {
    path: '/about/director-message',
    element: <DirectorMessagePage />,
  },
  {
    path: '/about/history',
    element: <HistoryPage />,
  },
  {
    path: '/about/team',
    element: <TeamPage />,
  },
  {
    path: '/about/advisory-board',
    element: <AdvisoryBoardPage />,
  },
  {
    path: '/about/vacancies',
    element: <VacanciesPage />,
  },
  {
    path: '/academics',
    element: <AcademicsPage />,
  },
  {
    path: '/academics/early-years',
    element: <EarlyYearsPage />,
  },
  {
    path: '/academics/primary',
    element: <PrimaryPage />,
  },
  {
    path: '/academics/secondary',
    element: <SecondaryPage />,
  },
  {
    path: '/admissions',
    element: <AdmissionsPage />,
  },
  {
    path: '/admissions/process',
    element: <AdmissionsProcessPage />,
  },
  {
    path: '/admissions/exams',
    element: <ExamsPage />,
  },
  {
    path: '/admissions/virtual-tour',
    element: <VirtualTourPage />,
  },
  {
    path: '/student-life',
    element: <StudentLifePage />,
  },
  {
    path: '/student-life/sports',
    element: <SportsPage />,
  },
  {
    path: '/student-life/leadership',
    element: <LeadershipPage />,
  },
  {
    path: '/student-life/alumni',
    element: <AlumniPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/gallery/video',
    element: <VideoGallery />,
  },
  {
    path: '/portal/admin',
    element: <AdminPortalPage />,
  },
  {
    path: '/portal/teachers',
    element: <TeachersPortalPage />,
  },
  {
    path: '/portal/parents',
    element: <ParentPortalPage />,
  },
  {
    path: '/portal/alumni',
    element: <AlumniPortalPage />,
  },
  {
    path: '/portal/students',
    element: <StudentPortalPage />,
  },
  {
    path: '/portal/results',
    element: <CheckResultPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
